/**
 *
 *
 *
 *
 *
 */
export function onAnimationEnd(
  element: Element | HTMLElement,
  options: Parameters<HTMLElement["getAnimations"]>[0] = {},
): Promise<PromiseSettledResult<Animation>[]> {
  const animations = element.getAnimations(options);
  return Promise.allSettled(animations.map((animation) => animation.finished));
}

/**
 *
 *
 *
 *
 *
 */
export const waitForAnimations = (
  elements: Element[],
  options: Parameters<HTMLElement["getAnimations"]>[0] = {},
): Promise<PromiseSettledResult<Animation>[]> =>
  Promise.allSettled(
    elements.flatMap((el) => el.getAnimations?.(options).map((anim) => anim.finished)),
  );
